import { z } from 'zod';
import { ObjectIdSchema } from './object-id.schema';
/**
 * Source Step Schema
 * Represents a single source node (step or start event node) with its
 * associated rule IDs.
 */ export const SourceStepSchema = z.object({
    stepId: z.string(),
    ruleIds: z.array(z.string()).optional()
});
/**
 * Step Input Event Schema
 * Represents an event input that triggers a process step.
 *
 * `eventId` links the input to a first-class event node (ADR 0003). Optional
 * for backwards compatibility with legacy event inputs created before
 * first-class event nodes existed; those are lazy-upgraded on first
 * interaction.
 *
 * A `sourceSteps` entry naming a start event node id marks the input as
 * served by the process start (formerly the `'START'` sentinel, drained by
 * migration M2). The tag round-trips through every carrier — draft steps,
 * draft assignments (a converted step keeps its event inputs, and
 * restore/undo echoes them back), live assignment rows, and recordings.
 */ export const StepInputEventSchema = z.object({
    inputType: z.literal('event'),
    eventId: ObjectIdSchema.optional(),
    type: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    sourceSteps: z.array(SourceStepSchema).optional(),
    notRemovable: z.boolean().optional()
});
/**
 * Step Input Previous Output Schema
 * Represents an output from a previous step used as input
 */ export const StepInputPreviousOutputSchema = z.object({
    inputType: z.literal('previous_output'),
    name: z.string().optional(),
    description: z.string().optional(),
    sourceSteps: z.array(SourceStepSchema).optional(),
    notRemovable: z.boolean().optional()
});
/**
 * Step Input Schema
 * Union of all possible input types for a process step
 */ export const StepInputSchema = z.discriminatedUnion('inputType', [
    StepInputEventSchema,
    StepInputPreviousOutputSchema
]);

//# sourceMappingURL=step-input.schema.js.map